import * as signalR from '@microsoft/signalr';
import {config} from "../config/config";

export class SignalRHub {
  private connection: signalR.HubConnection;

  constructor(
    url: string = config.SIGNALR_HUB_URL
  ) {
    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(url,{
        withCredentials: false,
      })
      .withAutomaticReconnect()
      .build();
  }

  on(event: string, handler: (...args: any[]) => void) {this.connection.on(event, handler);}
  off(event: string, handler: (...args: any[]) => void) {this.connection.off(event, handler);}
  async start() {if (this.connection.state === signalR.HubConnectionState.Disconnected) await this.connection.start();}
  async stop() {if (this.connection.state !== signalR.HubConnectionState.Disconnected) await this.connection.stop();}
  get state() {return this.connection.state;}
}
